import React from 'react';

import { ExperienceSuccess } from '@confluence/experience-tracker/entry-points/component.ts';

const TopLevelComponent = ({ forgeDoc, render, onTearDown }) => {
	if (forgeDoc.children.length === 0) {
		onTearDown && onTearDown();
	}

	return forgeDoc.children.map(render);
};

export const makeTopLevelComponent =
	(props: any) =>
	({ forgeDoc, render }: { forgeDoc: any; render: any }): React.JSX.Element => {
		return (
			<>
				{props.experienceName && <ExperienceSuccess name={props.experienceName} />}
				<TopLevelComponent
					key="top-level-component"
					{...props}
					forgeDoc={forgeDoc}
					render={render}
				/>
			</>
		);
	};
